import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const externalWorkLocationCrudActionTypes = generateEntityCrudActionTypes('externalWorkLocation')

export default { ...externalWorkLocationCrudActionTypes }
